import { ItineraryService } from './../itinerary.service';
import { ShortnedLink } from './../shortened-link';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Itinerary, ItineraryActivityType, ItineraryActivityTypeData, Day, DayActivity } from './../itineray.model';
import { Component, OnInit } from '@angular/core';

import * as firebase from "firebase/app";
import "firebase/firestore";

@Component({
  selector: 'app-itinerary-day-activities',
  templateUrl: './itinerary-day-activities.component.html',
  styleUrls: ['./itinerary-day-activities.component.css']
})
export class ItineraryDayActivitiesComponent implements OnInit {

  itinerary: Itinerary;

  day: Day;

  dayId: number;

  activityTypesData = ItineraryActivityTypeData.values();

  expanded: boolean[];

  constructor(private snackBar: MatSnackBar, private route: ActivatedRoute, public itineraryService: ItineraryService) { }

  ngOnInit() {
    this.itinerary = this.route.parent.parent.snapshot.data.itinerary;
    this.route.parent.params.subscribe(params => {
      this.dayId = parseInt(params["dayId"]) - 1;
      this.day = this.itinerary.days[this.dayId];
      this.syncExpanded();
    });
  }

  private syncExpanded(expandLast: boolean = false) {
    this.expanded = [];
    this.day.activities.forEach(() => this.expanded.push(false));
    if (expandLast) {
      this.expanded[this.expanded.length - 1] = true;
    }
  }

  getActivityTypeIcon(activity: DayActivity) {
    return ItineraryActivityTypeData.get(activity.type);
  }

  removeActivity($event, activity) {
    $event.stopPropagation();
    if (confirm("Vuoi veramente eliminare questa attività?")) {
      const idx = this.day.activities.indexOf(activity);
      this.day.activities.splice(idx, 1);
      this.snackBar
        .open("Attività eliminata", "Annulla", {
          duration: 4000
        })
        .onAction()
        .subscribe(() => {
          this.day.activities.splice(idx, 0, activity);
          this.snackBar.open(
            "L'attività che avevi eliminato è stata inserita nuovamente nella lista.",
            null,
            {
              duration: 4000
            }
          );
        });
      this.syncExpanded();
    }
  }

  addActivity(type?: ItineraryActivityType) {
    const lastActivity = this.day.activities.length > 0 ? this.day.activities[this.day.activities.length - 1] : null;
    let delta = ((lastActivity && lastActivity.duration && lastActivity.duration.hours) ? lastActivity.duration.hours * 60 * 60 : 0) + ((lastActivity && lastActivity.duration && lastActivity.duration.minutes) ? lastActivity.duration.minutes * 60 : 0);
    if (delta === 0) {
      delta = 30 * 60;
    }
    this.day.activities.push({
      type: type || ItineraryActivityTypeData.values()[0].key,
      time: new firebase.firestore.Timestamp((lastActivity ? lastActivity.time : this.day.date).seconds + delta, 0),
      title: "",
      image: null,
      description: "",
      link: { longUrl: null, shortUrl: null },
      price: null,
      priceLabel: null,
      reservationId: null,
      place: null,
      duration: { hours: null, minutes: null }
    });
    this.syncExpanded(true);
  }

  sortActivities(activities: DayActivity[]) {

    const getOnlyTimeInMs = (d: Date) => {
      return d.getHours() * 60 * 60 * 1000 +
        d.getMinutes() * 60 * 1000 +
        d.getSeconds() * 1000;
    }

    activities.sort((a: DayActivity, b: DayActivity) => {
      const ats = (a !== null && a.time !== null) ? getOnlyTimeInMs(a.time.toDate()) : null;
      const bts = (b !== null && b.time !== null) ? getOnlyTimeInMs(b.time.toDate()) : null;
      if (ats < bts) {
        return -1;
      } else if (ats > bts) {
        return 1;
      } else {
        return 0;
      }
    });
    return activities;
  }

}
